import type { ErrorEvent } from '@sentry/core'
import { CHUNK_LIST } from '../constants'
import isAnError from './isAnError'
import searchOnFrames from './searchOnFrames'

const isChunkError = (event: ErrorEvent): boolean => {
  return isAnError(event) && searchOnFrames(event, CHUNK_LIST)
}

export default isChunkError
